module.exports = __webpack_public_path__ + "static/assinatura-digital-receitas-tab-e122923dba8deebd6413a0a1e65aff2d.png";